import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'

const rootStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    '& > span': {
        fontWeight: 'bold',
    },
})

interface TrendingBannerProps {
    text?: string
    diffStyleOverrides?: CSSProperties
    styleOverrides?: CSSProperties
    hideIcon?: boolean
    diff: number
}

const TrendingBanner = memo((props: TrendingBannerProps) => {
    const {
        text = 'viewers in last minute',
        diffStyleOverrides,
        styleOverrides,
        hideIcon,
        diff,
    } = props

    return (
        <div
            css={rootStyles}
            data-testid="Container__TrendingBanner"
            style={styleOverrides}
        >
            {hideIcon ? '' : '🔥'}
            <span style={diffStyleOverrides}>+{diff}</span>
            {text}
        </div>
    )
})

export default TrendingBanner
export { TrendingBanner }
